<template>
	<v-autocomplete
		:value="value"
		:rules="rules"
		@change="emitChange($event)"
		:items="items"
		:loading="loading"
		item-text="name"
		item-value="id"
		ref="bundleId_field"
		:menu-props="{contentClass: 'grv-menu'}"
		:search-input.sync="search"
		:readonly="readonly"
		:multiple="multiple"
		auto-select-first
		dense
		no-filter
		hide-no-data
		small-chips
		deletable-chips
		placeholder="Rechercher un Bundle"
		:hint="hint">
		<template v-slot:label>
			<span v-if="param">
				{{ param | maestroParamLabel }}
			</span>
		</template>
		<!-- <template v-slot:selection="data">
				<v-chip
					label small
					color="white color--text"
					class="ma-0 mr-2 font-weight-bold">
					#{{ data.item.id }}
				</v-chip>
				<span class="pr-2">
					{{ data.item.name }}
				</span>
		</template> -->
		<template v-slot:item="data">
			<v-list-tile-avatar>
				<v-chip
					label small
					color="white color--text"
					class="ma-0 font-weight-bold">
					#{{ data.item.id }}
				</v-chip>
			</v-list-tile-avatar>
			<v-list-tile-content>
				<v-list-tile-title>
					{{ data.item.name }}
				</v-list-tile-title>
				<v-list-tile-sub-title class="font-italic caption">
					{{ data.item.description }}
				</v-list-tile-sub-title>
			</v-list-tile-content>
		</template>
	</v-autocomplete>
</template>

<script>
import { debounce } from 'debounce'
export default {
	props: [ 'value', 'rules', 'param', 'hint', 'readonly' ],
	data () {
		return {
			items: [],
			ids: [],
			search: null,
			loading: false
		}
	},
	computed: {
		multiple () {
			return this.param.type === 'multi-bundleid'
		}
	},
	watch: {
		search (val) {
			if (val && this.ids.indexOf(val) === -1) {
				this.bundleSearch(val)
			}
		},
		value (val) {
			if (Array.isArray(val)) {
				let needGetBundles = false
				val.map(id => {
					if (this.ids.indexOf(id) === -1) needGetBundles = true
				})
				if (needGetBundles) this.getBundles(val)
			} else {
				if (val && this.ids.indexOf(val) === -1) this.getBundles(val)
			}
		}
	},
	methods: {
		emitChange (val) {
			this.$emit('change', val)
		},
		bundleSearch: debounce(function (search) {
			if (!search) return
			if (search.length < 3 && isNaN(parseInt(search))) return
			if (this.loading) return
			this.getBundles(search)
		}, 100),
		getBundles (search) {
			this.loading = true
			this.$EsMaestro.bundle_search(search)
				.then(bundles => {
					this.items = bundles
					this.ids = this.items.map(bundle => bundle.id)
					if (bundles.length === 1) {
						let value = bundles[0].id
						if (parseInt(search) === value) {
							if (this.multiple) value = [ value ]
							this.emitChange(value)
						}
					}
				})
				.catch(err => {
					console.log(err)
				})
				.finally(() => (this.loading = false))
		}
	}
}
</script>

<style lang="stylus" scoped>
.dense_input
	>>>.v-select__selections
		margin-left: 0 !important
		flex-wrap: nowrap
		.v-chip__content
			padding: 0 0 0 4px
		.label-id
			padding: 0 4px 0 4px
			margin-left: 2px
			background-color: white
			color: var(--v-color-base)
			font-weight: bold
.v-input
	>>>.v-chip
		background-color: var(--v-background-darken1) !important
</style>



// WEBPACK FOOTER //
// src/components/field_bundle_id.vue